var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c(
          "fragment",
          [
            _c("skp-breadcrumbs", {
              on: {
                "page-title": function(val) {
                  return (_vm.pageTitle = val)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "register_wrap" }, [
          _c("div", { staticClass: "step_wrap" }, [
            _c(
              "ul",
              _vm._l(_vm.stepList, function(item) {
                return _c(
                  "li",
                  {
                    key: _vm.step + item.index + item.codeName,
                    class: _vm.getActiveClass(item.code, item.index)
                  },
                  [
                    _c("em", [_vm._v(_vm._s(item.index))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(item.codeName))])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "create_table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("caption", [
              _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("FIELD.GLOBAL.MANDATORY")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION"))),
                "Q" === _vm.step
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                "Q" === _vm.step
                  ? _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          { name: "clearable", rawName: "v-clearable" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.version,
                            expression: "version"
                          }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text" },
                        domProps: { value: _vm.version },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.version = $event.target.value
                          }
                        }
                      })
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.version))])
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v("OLD Version"),
                "Q" === _vm.step
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                "Q" === _vm.step
                  ? _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          { name: "clearable", rawName: "v-clearable" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.oldVersion,
                            expression: "oldVersion"
                          }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text" },
                        domProps: { value: _vm.oldVersion },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.oldVersion = $event.target.value
                          }
                        }
                      })
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.oldVersion))])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.CODE.TITLE")) + " "),
                "Q" === _vm.step
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                "Q" === _vm.step
                  ? _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          { name: "clearable", rawName: "v-clearable" },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.title,
                            expression: "title"
                          }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder:
                            "Enter subject with less than 90 characters",
                          maxlength: "90"
                        },
                        domProps: { value: _vm.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.title = $event.target.value
                          }
                        }
                      })
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.title))])
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "pl-20 txt_warning", attrs: { colspan: "2" } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.title,
                          expression: "!title"
                        }
                      ]
                    },
                    [_vm._v("※ Enter subject with less than 90 characters.")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "div_wrap", attrs: { colspan: "4" } }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.KNOWLEDGE.VERHISTORY")) +
                    "\n                        "
                ),
                "Q" === _vm.step || [1, 3, 5, 7].includes(_vm.modify)
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm.modifys.includes(_vm.status)
                  ? _c(
                      "a",
                      {
                        staticClass: "ico_write_global",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.modifyBtn(1)
                          }
                        }
                      },
                      [_c("span", { staticClass: "sr_only" })]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "border_top_none" }, [
              _c("td", { staticClass: "div_wrap", attrs: { colspan: "4" } }, [
                _c("div", { staticClass: "namo_wrap" }, [
                  _c("table", { staticClass: "data_table" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("thead", [
                      _c("tr", { staticClass: "text_center" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION")))
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("BUTTON.FAST.DATE")))]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.EDITOR")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DETAILS")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "text_center" },
                      [
                        _c("tr", [
                          _c("td", { staticClass: "pc_only" }, [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.version) +
                                "\n                                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pc_only" }, [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.date) +
                                "\n                                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pc_only" }, [
                            _vm._v(_vm._s(_vm.loginName))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text_left" }, [
                            "Q" === _vm.step ||
                            [1, 3, 5, 7].includes(_vm.modify)
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.details,
                                      expression: "details"
                                    }
                                  ],
                                  staticClass: "toolTextArea",
                                  domProps: { value: _vm.details },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.details = $event.target.value
                                    }
                                  }
                                })
                              : _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getMessage(_vm.details)
                                    )
                                  }
                                })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.versionList, function(info) {
                          return _c("tr", [
                            _c("td", [_vm._v(_vm._s(info.VERSION))]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pc_only" }, [
                              _vm._v(_vm._s(info.REG_DATE))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "pc_only" }, [
                              _vm._v(_vm._s(info.REG_NAME))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text_left" }, [
                              _c("div", [_vm._v(_vm._s(info.DESCRIPTION))])
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { colspan: "4" } }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.TEST.RESULT")) +
                    "\n                        "
                ),
                "Q" === _vm.step || [2, 3, 6, 7].includes(_vm.modify)
                  ? _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  : _vm.modifys.includes(_vm.status)
                  ? _c(
                      "a",
                      {
                        staticClass: "ico_write_global",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.modifyBtn(2)
                          }
                        }
                      },
                      [_c("span", { staticClass: "sr_only" })]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "border_top_none" }, [
              _c(
                "td",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        "Q" === _vm.step || [2, 3, 6, 7].includes(_vm.modify),
                      expression:
                        "'Q' === step || [2, 3, 6, 7].includes(modify)"
                    }
                  ],
                  attrs: { colspan: "4" }
                },
                [
                  _c("cross-editor", {
                    attrs: {
                      editorId: _vm.pageName,
                      editorData: _vm.stripHtml(_vm.testResult)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(
                        "Q" === _vm.step || [2, 3, 6, 7].includes(_vm.modify)
                      ),
                      expression:
                        "!('Q' === step || [2, 3, 6, 7].includes(modify))"
                    }
                  ],
                  attrs: { colspan: "4" }
                },
                [
                  _c("div", {
                    staticClass: "namoClass",
                    domProps: {
                      innerHTML: _vm._s(_vm.stripHtml(_vm.testResult))
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "Q" === _vm.step,
                    expression: "'Q' === step"
                  }
                ]
              },
              [
                _c("th", { attrs: { colspan: "4" } }, [
                  _c("span", { staticClass: "fL" }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.ATTACH.TOOL")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "gridtop_wrap_th fL" }, [
                    _c("em", { staticClass: "txt_info" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("MESSAGE.ATTACH.INTERNET.EXPLORER")) +
                          "\n                            "
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "Q" === _vm.step,
                    expression: "'Q' === step"
                  }
                ],
                staticClass: "border_top_none"
              },
              [
                _c(
                  "td",
                  { staticClass: "div_wrap", attrs: { colspan: "4" } },
                  [
                    _vm.attachToolView && "Q" === _vm.step
                      ? _c("innorix-upload", {
                          attrs: {
                            id: _vm.pageName + "AttachTool",
                            name: _vm.pageName + "AttachTool",
                            uploadId: _vm.pageName + "AttachTool",
                            onlyUpload: _vm.onlyUpload,
                            attachList: _vm.attachTool,
                            serviceType: _vm.serviceType,
                            toolManager: _vm.path
                          },
                          on: { files: _vm.setToolFiles }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.attachTool.length > 0 &&
                    _vm.attachToolView &&
                    "Q" !== _vm.step
                      ? _c("innorix-download", {
                          attrs: {
                            uploadId: _vm.pageName + "AttachTool",
                            serviceType: _vm.serviceType,
                            attachList: _vm.attachTool
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "Q" !== _vm.step,
                    expression: "'Q' !== step"
                  }
                ]
              },
              [
                _c("th", { attrs: { colspan: "4" } }, [
                  _c("span", { staticClass: "fL" }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.ATTACH.MANUAL"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: "Q" !== _vm.step,
                    expression: "'Q' !== step"
                  }
                ]
              },
              [
                _c(
                  "td",
                  { staticClass: "div_wrap", attrs: { colspan: "4" } },
                  [
                    _vm.attachManualView && _vm.modifys.includes(_vm.status)
                      ? _c("innorix-upload", {
                          attrs: {
                            id: _vm.pageName + "attachManual",
                            name: _vm.pageName + "attachManual",
                            uploadId: _vm.pageName + "attachManual",
                            onlyUpload: _vm.onlyUpload,
                            attachList: _vm.attachManual,
                            serviceType: _vm.serviceType
                          },
                          on: { files: _vm.setManualFiles }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.attachTool.length > 0 &&
                    _vm.attachManualView &&
                    !_vm.modifys.includes(_vm.status)
                      ? _c("innorix-download", {
                          attrs: {
                            uploadId: _vm.pageName + "attachManual",
                            serviceType: _vm.serviceType,
                            attachList: _vm.attachManual
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            "P" === _vm.step
              ? _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.PILOT.TESTER")))]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("table", { staticClass: "data_table" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("thead", [
                        _c("tr", { staticClass: "text_center" }, [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("FIELD.ASCCENTER.NO")))
                          ]),
                          _vm._v(" "),
                          _c("th")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "text_center" },
                        _vm._l(_vm.pilotList, function(item, idx) {
                          return _c("tr", [
                            _c("td", [
                              _c("label", { staticClass: "serial-wrap" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.SUBSIDIARY,
                                      expression: "item.SUBSIDIARY"
                                    }
                                  ],
                                  staticClass: "text_input w100p",
                                  attrs: { type: "text" },
                                  domProps: { value: item.SUBSIDIARY },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "SUBSIDIARY",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("label", { staticClass: "serial-wrap" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.ASC,
                                      expression: "item.ASC"
                                    }
                                  ],
                                  staticClass: "text_input w100p",
                                  attrs: { type: "text" },
                                  domProps: { value: item.ASC },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(item, "ASC", $event.target.value)
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text_right" }, [
                              _c("span", { staticClass: "in-btn-item" }, [
                                idx === _vm.pilotList.length - 1
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "ico_btn_add",
                                        attrs: { href: "javascript:" },
                                        on: {
                                          click: function($event) {
                                            return _vm.btnAddSerial()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr_only" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("BUTTON.GLOBAL.ADD"))
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "ico_btn_remove",
                                    attrs: { href: "javascript:" },
                                    on: {
                                      click: function($event) {
                                        return _vm.btnRemoveSerial(idx)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "sr_only" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("BUTTON.GLOBAL.REMOVE"))
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }, [
          _c(
            "a",
            {
              staticClass: "btn_white size_full",
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.pageMove("toolManageList")
                }
              }
            },
            [_vm._v("List")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.version ||
                    !_vm.oldVersion ||
                    (0 === _vm.attachToolFileSeq.length &&
                      0 === _vm.attachTool.length) ||
                    ("Q" !== _vm.step &&
                      0 === _vm.attachManualFileSeq.length &&
                      0 === _vm.attachManual.length),
                  expression:
                    "\n                    !version ||\n                        !oldVersion ||\n                        (0 === attachToolFileSeq.length && 0 === attachTool.length) ||\n                        ('Q' !== step && 0 === attachManualFileSeq.length && 0 === attachManual.length)\n                "
                }
              ],
              staticClass: "pl-20 txt_warning"
            },
            [
              _vm._v(
                "\n                ※ Check the mandatory field(s).\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    "Complete" === _vm.status && "Y" === _vm.params.creationYn,
                  expression:
                    "'Complete' === status && 'Y' === params.creationYn"
                }
              ],
              staticClass: "btn_right"
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn_white",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.seeNotificationPop()
                    }
                  }
                },
                [_vm._v("\n                    Notification\n                ")]
              ),
              _vm._v(" "),
              "O" === _vm.step &&
              "O" !== _vm.reqType &&
              "Complete" === _vm.status
                ? _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.request(_vm.step)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("FIELD.PUBLIC.RELEASE")) +
                          "\n                    "
                      ),
                      _c("em", { staticClass: "ico_infoW_btn" }, [
                        _c("i", { staticClass: "tooltip fl_right" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("MESSAGE.PUBLIC.RELEASE")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: "Release" === _vm.status,
                  expression: "'Release' === status"
                }
              ],
              staticClass: "btn_right"
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn_blue",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.seeApprovalHistoryPop(_vm.approvalId)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.ETC.001")) +
                      "\n                "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.modifys.includes(_vm.status) &&
                    "Y" === _vm.params.creationYn,
                  expression:
                    "modifys.includes(status) && 'Y' === params.creationYn"
                }
              ],
              staticClass: "btn_right"
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn_white",
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.seeNotificationPop()
                    }
                  }
                },
                [_vm._v("\n                    Notification\n                ")]
              ),
              _vm._v(" "),
              "" !== _vm.toolId && "Complete" !== _vm.status
                ? _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.save("Discard")
                        }
                      }
                    },
                    [_vm._v("\n                    Discard\n                ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              "Complete" !== _vm.status
                ? _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.save("Draft")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("FIELD.GLOBAL.DRAFT")) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              "Q" === _vm.step && "Q" !== _vm.reqType
                ? _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.request(_vm.step)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("FIELD.UPLOAD.QASERVER")) +
                          "\n                    "
                      ),
                      _c("em", { staticClass: "ico_infoW_btn" }, [
                        _c("i", { staticClass: "tooltip fl_right" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("MESSAGE.GSPN.QA.SERVER")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              "P" === _vm.step && "P" !== _vm.reqType
                ? _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.request(_vm.step)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("FIELD.PLIOT.RELEASE")) +
                          "\n                    "
                      ),
                      _c("em", { staticClass: "ico_info_btn" }, [
                        _c("i", { staticClass: "tooltip fl_right" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("MESSAGE.PLIOT.RELEASE")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !["Q", "O"].includes(_vm.step)
                ? _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.next(_vm.step)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              "O" === _vm.step &&
              ["Draft", "Ongoing", "Rejected", "Canceled"].includes(_vm.status)
                ? _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.next(_vm.step)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("TITLE.GLOBAL.APPROVAL")) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "154" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "10%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "10%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "45%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "45%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26694416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26694416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/tool/toolManageDetail.vue
// module id = fWZL
// module chunks = 0